import React, {useState} from "react";
import cardImg from "./assets/cardimg.png";
import cardImg1 from "../../Home/CardsStatusSection/assets/1.png";
import cardImgIcon from "../../Home/CardsStatusSection/assets/drop.png";
import Card from "../Card/Card";
const ProjectsRaised = () => {
  return (
    <div className="container mt-[80px] md:mt-[200px]">
      <div className="container-1240">
        <div className="flex flex-col gap-y-[30px] md:flex-row justify-between items-center md:items-stretch">
          <div>
            <h2 className="text-res-lg font-extrabold">Projects Raised</h2>
            <p className="text-res-normal leading-[29px] ">
              Projects funded by DAO
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-[29px]">
            <div className="bg-custom-gradient w-[200px] rounded-[10px] text-center p-[10px] h-auto md:h-[72px]  flex justify-center items-center">
              <div>
                <h2 className="text-main-black font-black text-res-sm">
                  $250M+
                </h2>
                <p
                  className="text-res-xxs text-main-black font-semibold
                            leading-[26px]"
                >
                  Total Amount Raised
                </p>
              </div>
            </div>
            <div className="bg-custom-gradient w-[200px] rounded-[10px] text-center p-[10px] h-auto md:h-[72px]  flex justify-center items-center">
              <div>
                <h2 className="text-main-black font-black text-res-sm">150+</h2>
                <p className="text-res-xxs text-main-black font-semibold leading-[26px]">
                  {" "}
                  Raises Completed{" "}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* cards  */}
        <div className="mt-[20px] grid gird-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-[47px] gap-x-[20px]">
          <Card cardImg1={cardImg1} cardImgIcon={cardImgIcon}></Card>
          <Card cardImg1={cardImg1} cardImgIcon={cardImgIcon}></Card>
          <Card cardImg1={cardImg1} cardImgIcon={cardImgIcon}></Card>
        </div>
      </div>
    </div>
  );
};

export default ProjectsRaised;
